module.exports = require('./dist/commonjs/main.js').default;
